<template>
  <div class="stock-page">
    <div class="block">
      <div class="hd">
        <div v-for="item in tabData" :class="['tab', {'current': tabKey==item}]" v-text="item" @click="tabSwitch(item)"></div>
      </div>
      <div class="item-block" v-show="tabKey!='货位标记'">
        <div class="itm"><span class="shelfno" v-text="shelfNo+'#货架'" v-if="viewKey=='货位'"></span></div>
        <div class="itm">
          <span class="swbtn" v-for="item in viewTypes" :class="[{'current': viewKey==item}]" v-text="item" @click="viewSwitch(item)"></span>
        </div>
      </div>
      <div class="chart-box" v-if="tabKey=='利用率'">
        <v-chart :options="options_lyl" />
      </div>
      <div class="chart-box" v-if="tabKey=='周转率'">
        <v-chart :options="options_zzl" />
      </div>
      <div class="chart-box" v-if="tabKey=='货位标记'">
        <v-chart :options="options_hwbj" />
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
export default{
  data() {
    let tabData = [
      '利用率', '周转率', '货位标记'
    ];
    let viewTypes = [
      '库区', '货架', '货位'
    ];

    return {
      tabData: tabData,
      tabKey: tabData[0],
      viewTypes: viewTypes,
      viewKey: viewTypes[0],
      shelfNo: 1,
      lylList: [],
      options_lyl: {},
      zzlList: [],
      options_zzl: {},
      hwbjList: [],
      options_hwbj: {},
    }
  },
  mounted() {
    //定义全局方法
    window.gbfc_viewSwitch = this.viewSwitch;
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);
  },
  methods: {
    tabSwitch(item) {
      this.tabKey = item;
      this.resetData();
    },
    viewSwitch(item, shelfNo) {
      this.shelfNo = shelfNo ? shelfNo : 1;
      this.viewKey = item;
      this.resetData();
    },
    resetData() {
      console.log(this.tabKey+'-'+this.viewKey);
      if(this.tabKey == '利用率') {
        this.getLylList();
      } else if(this.tabKey == '周转率') {
        this.getZzlList();
      } else if(this.tabKey == '货位标记') {
        this.getHwbjList();
      }
    },

    getLylList() {
      let self = this;
      let url = '';
      if(this.viewKey == '库区') {
        url = '/api/DataStatistical/Day_Cap_UtilRto';
      } else if(this.viewKey == '货架') {
        url = '/api/DataStatistical/Shelf_Cap_UtilRto';
      } else if(this.viewKey == '货位') {
        url = '/api/DataStatistical/ShelfGrid_Cap_UtilRto';
      } else {
        return;
      }
      this.$handleRequest(window.ApiHost1+url, {
        "WareHouseCode":"00" + window.PYKWareHouseCode,
        "ShelfNo": this.shelfNo,
      }, 'post', function(res) {  //success
        console.log(res)
        self.lylList = res.retData.Rows ? res.retData.Rows : res.retData;
        self.setOptionsLyl();

      }, function(res) {  //fail

      console.log("失败"+JSON.stringify(res))
      });
    },
    setOptionsLyl() {
      let self = this;
      let colors = this.$charts.colors.style_8;
      let chartsConf = this.$charts[window.CurrentTheme];
      //let legendData = ['出库占比', '入库占比'];
      let xdata = [];
      let sdata = [];
      let ldata = [];

      //单个
      if(typeof(this.lylList.length) == 'undefined') {
        let dataStyle = {
          normal: {
            label: {show:false},
            labelLine: {show:false}
          }
        };
        this.lylList.Ratio = Math.floor(this.lylList.Ratio * 100) / 100;
        this.options_lyl = {
          title: {
            text: this.lylList.Ratio+'%',
            x: 'center',
            y: 'center',
            itemGap: 20,
            textStyle : {
              color : colors[0],
              fontSize : 36,
              fontWeight : 'bolder'
            }
          },
          series : [
            {
              type: 'pie',
              clockWise: true,
              radius : [84, 90],
              itemStyle : dataStyle,
              data:[
                {
                  value: 100,
                  itemStyle : {
                    normal:{
                      color: chartsConf.series.color_1,
                    }
                  }
                }
              ]
            },
            {
              type: 'pie',
              clockWise: true,
              radius : [71, 90],
              itemStyle : dataStyle,
              data:[
                {
                  value: this.lylList.Ratio,
                  itemStyle: {
                    normal:{
                      //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                      color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                        {offset: 0, color: colors[0]}, {offset: 1, color: colors[1]}
                      ]),
                    }
                  }
                },
                {
                  value: 100-this.lylList.Ratio,
                  name:'invisible',
                  itemStyle : {
                    normal : {
                      color: 'rgba(0,0,0,0)',
                      label: {show:false},
                      labelLine: {show:false}
                    },
                    emphasis : {
                      color: 'rgba(0,0,0,0)'
                    }
                  }
                }
              ]
            },
          ]
        };
        return;
      }

      //列表
      this.lylList.forEach( function(l, li) {
        let xlabel = l.Date || l.ShelfNo || l.ShelfGridRegionNo;
        if(self.viewKey == '货位') {
          if(xlabel == '1') {
            xlabel = '前排';
          } else if(xlabel == '2') {
            xlabel = '中间';
          } else if(xlabel == '3') {
            xlabel = '后排';
          }
        }
        xdata.push(xlabel);
        ldata.push(Math.round(l.Ratio*100)/100);
      });
      let xrotate = 0;
      let xfontSize = 20;
      let xname = '';
      if(this.viewKey == '库区') {
        xrotate = -40;
        xfontSize = 12;
      } else {
        xname = this.viewKey;
      }

      let tmp = {
        //name: l,
        type:'bar',
        barWidth: 8,//柱图宽度
        barGap: '65%',
        color: colors[0],
        markPoint: {
          data: [
            {type: 'max', name: '最大值'},
            {type: 'min', name: '最小值'}
          ]
        },
        symbol: 'circle',
        symbolSize: 15,
        data: ldata
      };
      sdata.push(tmp);

      this.options_lyl = {
        tooltip: {
          trigger: 'axis',
          axisPointer : {
            type : 'shadow'
          }
        },
        /*legend: {
          left: 0,
          textStyle: {
            color: "#fff",
            fontSize: 20
          },
          data: legendData
        },*/
        xAxis : [
          {
            type : 'category',
            name: xname,
            nameTextStyle: {
              color: chartsConf.xAxis.color,
              fontSize: 18
            },
            axisLabel: {
              color: chartsConf.xAxis.color,
              fontSize: xfontSize,
              rotate: xrotate,
              interval: 0,
              margin: 16,
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: chartsConf.xAxis.color_1,
                width: 1, //这里是为了突出显示加上的
              }
            },
            data : xdata
          }
        ],
        yAxis : [
          {
            type : 'value',
            axisLabel: {
              color: chartsConf.yAxis.color,
              fontSize: 20,
              formatter: '{value}%'
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: chartsConf.yAxis.color_1,
                width: 1, //这里是为了突出显示加上的
              }
            },
            splitLine: {
              show: true,
              lineStyle:{
                color: [chartsConf.yAxis.color_2],
                width: 1,
                type: 'solid'
              }
            },
          }
        ],
        series: sdata
      };
    },
    getZzlList() {
      let self = this;
      let url = '';
      if(this.viewKey == '库区') {
        url = '/api/DataStatistical/Day_Inv_ToRto';
      } else if(this.viewKey == '货架') {
        url = '/api/DataStatistical/Shelf_Inv_ToRto';
      } else if(this.viewKey == '货位') {
        url = '/api/DataStatistical/ShelfGrid_Inv_ToRto';
      } else {
        return;
      }

      this.$handleRequest(window.ApiHost1+url, {
        "WareHouseCode":"00" + window.PYKWareHouseCode,
        "ShelfNo": this.shelfNo,
      }, 'post', function(res) {  //success


        self.zzlList = res.retData.Rows ? res.retData.Rows : res.retData;
        self.setOptionsZzl();
      }, function(res) {  //fail
        console.log('--fail--', res)
      });
    },
    setOptionsZzl() {
      let self = this;
      let colors = this.$charts.colors.style_8;
      let chartsConf = this.$charts[window.CurrentTheme];
      let xdata = [];
      let sdata = [];
      let ldata = [];

      //单个
      if(typeof(this.zzlList.length) == 'undefined') {
        let dataStyle = {
          normal: {
            label: {show:false},
            labelLine: {show:false}
          }
        };
        this.zzlList.Ratio = Math.floor(this.zzlList.Ratio * 100) / 100;
        this.options_zzl = {
          //label: '今日周转率',
          title: {
            text: this.zzlList.Ratio+'%',
            x: 'center',
            y: 'center',
            itemGap: 20,
            textStyle : {
              color : colors[0],
              fontSize : 36,
              fontWeight : 'bolder'
            }
          },
          series : [
            {
              type: 'pie',
              clockWise: true,
              radius : [84, 90],
              itemStyle : dataStyle,
              data:[
                {
                  value: 100,
                  itemStyle : {
                    normal:{
                      color: chartsConf.series.color_1,
                    }
                  }
                }
              ]
            },
            {
              type: 'pie',
              clockWise: true,
              radius : [71, 90],
              itemStyle : dataStyle,
              data:[
                {
                  value: this.zzlList.Ratio,
                  itemStyle: {
                    normal:{
                      //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                      color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                        {offset: 0, color: colors[0]}, {offset: 1, color: colors[1]}
                      ]),
                    }
                  }
                },
                {
                  value: 100-this.zzlList.Ratio,
                  name:'invisible',
                  itemStyle : {
                    normal : {
                      color: 'rgba(0,0,0,0)',
                      label: {show:false},
                      labelLine: {show:false}
                    },
                    emphasis : {
                      color: 'rgba(0,0,0,0)'
                    }
                  }
                }
              ]
            },
          ]
        };
        return;
      }

      //列表
      this.zzlList.forEach( function(l, li) {
        let xlabel = l.Date || l.ShelfNo || l.ShelfGridRegionNo;
        if(self.viewKey == '货位') {
          if(xlabel == '1') {
            xlabel = '前排';
          } else if(xlabel == '2') {
            xlabel = '中间';
          } else if(xlabel == '3') {
            xlabel = '后排';
          }
        }
        xdata.push(xlabel);
        ldata.push(Math.round(l.Ratio*100)/100);
      });
      let xrotate = 0;
      let xfontSize = 20;
      let xname = '';
      if(this.viewKey == '库区') {
        xrotate = -40;
        xfontSize = 12;
      } else {
        xname = this.viewKey;
      }
      let tmp = {
        type:'line',
        color: colors[0],
        markPoint: {
          data: [
            {type: 'max', name: '最大值'},
            {type: 'min', name: '最小值'}
          ]
        },
        areaStyle: {},
        symbol: 'circle',
        symbolSize: 15,
        data: ldata
      };
      sdata.push(tmp);

      this.options_zzl = {
        tooltip: {
          trigger: 'axis',
          axisPointer : {
            type : 'line'
          }
        },
        xAxis: {
          type: 'category',
          name: xname,
          boundaryGap: false,
          nameTextStyle: {
            color: chartsConf.xAxis.color,
            fontSize: 18
          },
          axisLabel: {
            color: chartsConf.xAxis.color,
            fontSize: xfontSize,
            rotate: xrotate,
            interval: 0,
            margin: 16,
          },
          //设置轴线的属性
          axisLine:{
            lineStyle: {
              color: chartsConf.xAxis.color_1,
              width: 1, //这里是为了突出显示加上的
            }
          },
          data: xdata
        },
        yAxis : [
          {
            type : 'value',
            axisLabel: {
              color: chartsConf.yAxis.color,
              fontSize: 20,
              interval: 'auto',
              formatter: '{value}%'
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: chartsConf.yAxis.color_1,
                width: 1, //这里是为了突出显示加上的
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: [chartsConf.yAxis.color_2],
                width: 1,
                type: 'solid'
              }
            },
          }
        ],
        series: sdata
      };
    },
    getHwbjList() {
      let self = this;
      let url = '/api/DataStatistical/ShelfGrid_FlagRto';
      this.$handleRequest(window.ApiHost1+url, {
        "WareHouseCode":"00" + window.PYKWareHouseCode,
      }, 'post', function(res) {  //success


        self.hwbjList = res.retData.Rows;
        self.setOptionsHwbj();
      }, function(res) {  //fail
        console.log('--fail--', res)
      });
    },
    setOptionsHwbj() {
      let colors = this.$charts.colors.style_1;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      let legendData = [];      
      this.hwbjList.forEach( function(d, di) {
        legendData.push(d.ShelfGridFlagName);
        let color1 = colors[di][0];
        let color2 = colors[di][1];
        let tmp = {
          value: d.Count,
          name: d.ShelfGridFlagName,
          label: {
            normal: {
                rich: {
                  hr: {
                    borderColor: color2
                  },
                  per: {
                    color: color2
                  }
                }
            }
          },
          itemStyle:{
            normal:{
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {offset: 0, color: color1}, {offset: 1, color: color2}
              ])
            }
          }
        };
        sdata.push(tmp);
      });

      this.options_hwbj = {
        legend: {
          right: 100,
          textStyle: {
            color: chartsConf.legend.color,
            fontSize: 20
          },
          data: legendData
        },
        series: [
          {
            type:'pie',
            radius: ['38%', '55%'],
            center: ['50%', '65%'],
            avoidLabelOverlap: true,
            labelLine: {
              //length: 30,
              length2: 30
            },
            label: {
              normal: {
                  formatter: '{per|{d}%}{per|({c})}',
                  //formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                  //backgroundColor: '#061445',
                  //padding: 15,
                  //borderColor: '#5165b7',
                  //borderWidth: 1,
                  rich: {
                    hr: {
                      //borderColor: '#fff',
                      width: '100%',
                      borderWidth: 0.5,
                      height: 0,
                    },
                    b: {
                      align: 'center',
                      fontSize: 24,
                      color: chartsConf.series.color,
                      padding: [0, 0, 5, 0]
                    },
                    per: {
                      align: 'center',
                      fontSize: 24,
                      padding: [5, 0, 0, 0]
                    }
                  }
              }
            },
            data: sdata
          }
        ]
      };
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/xiayan/stock/StockChart1.vue